import { App } from "vue";
import { manager } from "./manager";

export function setupDirections(app: App) {
  app.directive("manager", manager);
}
